import { useCallback } from 'react';
import { prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'js/store/hooks';
import { useLogout } from 'js/hooks/auth/hooks/useLogout';
import { useLoginPopup } from 'js/components/popups/LoginPopup';
import { useSmartClosePopups } from 'js/components/common/PopupManager';
import { showLogoutNotificationPopupAction } from 'js/components/popups/LogoutNotificationPopup';

export const useHandleLogoutNotification = ({ isWrapper = false }: { isWrapper?: boolean } = {}) => {
    const logout = useLogout();
    const dispatch = useDispatch();
    const showLoginPopup = useLoginPopup();
    const closePopups = useSmartClosePopups();
    const isLoginAgainPopup = useAppSelector(prop('isLoginAgainPopup'));

    return useCallback(async (): Promise<void> => {
        await logout({ isQuiet: true, isManual: false });

        closePopups('logout');

        if (isWrapper) {
            dispatch(showLogoutNotificationPopupAction({
                // you should not relogin from the Wrapper
                isLoginAgainPopup: false,
                // in case it is closed -- close the window
                onClose: () => window.open('', '_self')?.close()
            }));
            return;
        }

        dispatch(showLogoutNotificationPopupAction({
            isLoginAgainPopup,
            onAccept: () => showLoginPopup()
        }));
    }, [dispatch, closePopups, logout, isLoginAgainPopup, showLoginPopup, isWrapper]);
};
